import { TYPE } from '../actions/types'

const intialState ={
    getHourlyAmenityRes:{},
    updateHourlyAmenityRes:{}
}

export default function (state = intialState, action,response=action.payload) {
    switch (action.type) {
        case TYPE.GET_PROPERTY_AMENITIES_HOURLY:
            state.getHourlyAmenityRes=response
            return { ...state, response: action.payload }
        case TYPE.UPDATE_HOURLY_AMENITIES:
            state.updateHourlyAmenityRes=response
            return { ...state, response: action.payload }
        case "clear_update_hourly_amenity_api_res" :
            state.updateHourlyAmenityRes={}
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

